import qs from 'qs';
import API from './baseAPI';

interface UserQuery {
  page?: string;
  userRole?: string;
  username?: string;
}

/**
 * @description 등록된 유저를 조회합니다. userRole 로 역할을, username 으로 이메일을 필터링할 수 있습니다.
 * @pagination
 */
const getUsers = async (query: UserQuery = {}) => {
  const params: UserQuery = {};
  (Object.keys(query) as Array<keyof UserQuery>).forEach((key) => {
    if (query[key]) params[key] = query[key];
  });
  const search = qs.stringify(params);
  const response = await API.get(`users${search ? `?${search}` : ''}`);
  return response;
};

/**
 * @description 로그인된 세션의 유저 정보를 조회합니다.
 */
const getUsersMe = async () => {
  const response = await API.get('users/me');
  return response;
};

/**
 * @description 로그인 요청합니다.
 */
const postLogin = async (username: string, password: string) => {
  const payload = { username, password };
  const response = await API.post('login', payload);
  return response;
};

/**
 * @description 로그아웃 요청합니다.
 */
const postLogout = async () => {
  const response = await API.post('logout', null);
  return response;
};

const putUserRole = async (username: string, userRole: string) => {
  const payload = { userRole };
  const response = await API.put(`users/${username}/userRole`, payload);
  return response;
};

export { getUsers, getUsersMe, postLogin, postLogout, putUserRole };
